import React from 'react';
import './IconLabel.scss';

export interface IIconLabelProps {
  text: string | null | undefined | JSX.Element;
  success: boolean | null | undefined;
}

export const IconLabel = ({
  text = '',
  success = false,
}: React.PropsWithChildren<IIconLabelProps>): JSX.Element | null =>
  text ? (
    <div>
      <i
        className={`icon-label--${success ? 'success' : 'danger'} mr-1 fas ${
          success ? 'fa-check-circle' : 'fa-times-circle'
        }`}></i>
      {text}
    </div>
  ) : null;
